

import { Fragment, useState, useEffect } from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Spinner,
} from "@material-tailwind/react";
import { useForm, Controller } from 'react-hook-form';
import { useShared } from "../../hooks/useShared";
import UploadFiles from "../upload/UploadFiles";
import AIcon from "../partials/AIcon";
import ARadio from "../fields/ARadio";
import AInput from "../fields/AInput";

export default function ApproveDialog({ v }) {
    const { http, openApproveDialog, setOpenApproveDialog, model, setModel, getNotifications,sendNotificationEmail } = useShared();
    const { register, handleSubmit, control, formState: { errors }, reset, setValue, watch } = useForm({});

    const [loading, setLoading] = useState({ modelLoading: false, uploadLoading: false })
    const [status, setStatus] = useState(null)


    const closeDialog = (value) => {
        setOpenApproveDialog(false)
        setModel(null)

    };

    const approveOrRject = (data) => {
        console.log("approve ", model, data)
         if (model?.id) {
             setLoading(pre => ({ ...pre, uploadLoading: true }))
             http.update(`api/${v.modelURL}/${model.id}`, data).then(res => {
                 console.log(res)
                 if (res.data.success)
                     closeDialog()
                 setLoading(pre => ({ ...pre, uploadLoading: false }))
                 getNotifications()
                 v.refersh()
                 sendNotificationEmail(res?.data?.data?.model)
             }, err => {
                 setLoading(pre => ({ ...pre, uploadLoading: false }))
             })
 
         }
    }


    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            setStatus(value?.status)
        })
        return () => subscription.unsubscribe()
    }, [watch])


    return (
        <Fragment>

            {loading.modelLoading ? <Spinner color="teal" className="h-4 w-4" />
                : <Dialog open={openApproveDialog} className={`min-w-[90%] md:min-w-[20%] border-main-color absolute top-0  overflow-y-scroll ${v?.className} `}
                    animate={{
                        mount: { scale: 1, y: 0 },
                        unmount: { scale: 0.9, y: -100 },
                    }}

                    size="sm"
                    onClose={() => null}
                >
                    <DialogHeader className="bg-main-color py-1 px-2 text-blue-gray-100  text-base flex justify-between" >تاييد {v.modelName}
                        <Button className="p-0 m-0 bg-transparent" onClick={closeDialog}>  <AIcon name="close-outline" size={20} className="p-1" /> </Button>
                    </DialogHeader>
                    <form onSubmit={handleSubmit(approveOrRject)}>
                        <DialogBody divider style={{ direction: 'rtl' }}>

                            <div className="flex gap-10">
                                <ARadio v={{ register, errors, control, data: { label: `لطفا  ${v.modelName}  را تایید یا رد کنید!`, name: 'status', options: [{ name: 2, label: `تاييد` }, { name: -1, label: `رد` },] } }} />
                            </div>
                            {status === '-1' && <AInput v={{ register, errors, control, data: { label: `علت`, name: 'description', type: "textarea" } }} />}


                        </DialogBody>
                        <DialogFooter className="py-1">
                            <Button
                                variant="text"
                                size="sm"
                                color="red"
                                onClick={closeDialog}
                                className="mr-1"
                            >
                                <span> بستن </span>
                            </Button>
                            <Button
                                size="sm"
                                className="btn1 w-full md:w-[15%] "
                                    type="submit"
                                disabled={loading.uploadLoading ||!status}>  {loading.uploadLoading ? <Spinner color="teal" className="h-4 w-4" /> : <span> ارسال</span>}
                            </Button>
                        </DialogFooter>
                    </form>
                </Dialog>}
        </Fragment>
    );
}

